.controls {
  width: 100%;
}
